module.exports = __webpack_public_path__ + "static/media/Ap_oral_selecionados_IIIMostra.e5f2a479.xlsx";